module.exports = __webpack_public_path__ + "i18n/pl.c8bb2becb1a999acb1278180e29ac7c5.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=i18n/[name].[hash].[ext]!./i18n/pl.json
// module id = 1860
// module chunks = 0